<template>
    <div>
        <div class="title">{{ $t('nBox.calibrationComments') }}</div>
        <b-form-textarea
            size="sm"
            class="scroll"
            :state="isValid"
            v-model="$v.form.text.$model"
        />
        <div class="d-flex justify-content-end mt-2">
            <b-button
                size="sm"
                class="send-comment"
                :disabled="isLoading"
                variant="outline-primary"
                @click="onClickSendComment"
            >
                <span>{{ $t('form.button.comment') }}</span>
                <span v-if="isLoading" class="ml-1">
                    <i class="fa fa-spinner fa-spin" />
                </span>
            </b-button>
        </div>
    </div>
</template>
<script>
import { EventBuzz } from '@/main'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createComment } from '@/views/n-box/report/api'
export default {
    mixins: [validationMixin],
    props: {
        user: {},
        nBox: {},
    },
    validations: {
        form: {
            text: {
                required,
            },
        },
    },
    data() {
        return {
            isLoading: false,
            form: {
                text: '',
            },
        }
    },
    computed: {
        isValid() {
            return this.$v.$dirty ? !this.$v.$invalid : null
        },
    },
    watch: {
        user() {
            this.resetForm()
        },
        nBox() {
            this.resetForm()
        },
    },
    methods: {
        onClickSendComment() {
            this.touchForm()
            if (!this.isValid) {
                return
            }

            this.sendComment()
        },
        touchForm() {
            this.$v.$touch()
        },
        sendComment() {
            const payload = this.getFormPayload()
            this.setLoader(true)
            createComment(payload)
                .then(comment => {
                    this.resetForm()
                    this.emitCreatedEvent(comment)
                })
                .finally(() => this.setLoader(false))
        },
        getFormPayload() {
            return {
                n_box_id: this.nBox.id,
                content: this.form.text,
                evaluated_id: this.user.id,
            }
        },
        resetForm() {
            this.form.text = ''
            this.$v.$reset()
        },
        emitCreatedEvent(comment) {
            EventBuzz.$emit('n-box-comment-created', comment)
        },
        setLoader(value) {
            this.isLoading = value
        },
    },
}
</script>
<style scoped>
.title {
    font-size: 12px;
    text-transform: uppercase;
}

.send-comment {
    padding: 0px 5px;
}
</style>
